import { Alert } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";

const toastService = (() => {
  const success = (message: string) => {
    toast.success(({ closeToast }) => (
      <Alert
        style={{
          background: "#EBF1FE",
        }}
        severity="success"
        onClose={closeToast}
      >
        {message}
      </Alert>
    ));
  };

  const error = (message: string) => {
    toast.error(
      <Alert
        sx={{
          background: "#FF7377",
        }}
        severity="error"
        onClose={() => toast.dismiss()}
      >
        {message}
      </Alert>
    );

  };

  return {
    error,
    success,
  };
})();

export default toastService;